import { useState } from 'react'
import { initialModalOptions, ModalOptions } from 'types/global'

type LicensePlateInputViewModelProps = {
  defaultValues?: any
  setFormDataChanged?: React.Dispatch<React.SetStateAction<boolean>>
}

export const useLicensePlateInputViewModel = (props: LicensePlateInputViewModelProps) => {
  const [licenseState, setLicenseState] = useState(props.defaultValues?.license_state || '')
  const [licensePlate, setLicensePlateValue] = useState(props.defaultValues?.license_plate || '')
  const [modalOptions, setModalOptions] = useState<ModalOptions>(initialModalOptions)

  const handlePlateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value
    // Prevent any non-alphanumeric characters from being pasted
    const alphanumericValue = value.replace(/[^a-zA-Z0-9]/g, '').toUpperCase()
    setLicensePlateValue(alphanumericValue)
    props.setFormDataChanged?.(true)
  }

  const handleStateChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const value = e.target.value
    setLicenseState(value)
    props.setFormDataChanged?.(true)
  }

  return {
    licenseState,
    licensePlate,
    modalOptions,
    setModalOptions,
    handlePlateChange,
    handleStateChange,
  }
}
